import React from 'react';
import PropTypes from 'prop-types';
import { isValid } from 'date-fns';
import { format, parse, formatLocal } from '@hobs/utils/formatWithTimeZone';
import { DATE_FORMAT, DATETIME_FORMAT } from '@hobs/utils/constants';
import { expandDataItem } from '@hobs/utils/expandItem';

export const CellDate = props => {
  const date = parse(props.dataItem[props.field]);

  if (date === '-' || !isValid(date)) {
    return <td className={props.className} />;
  }

  return (
    <td onClick={expandDataItem} className={props.className}>
      <div>{format(date, DATE_FORMAT)}</div>
    </td>
  );
};

export const CellDateTime = props => {
  const date = formatLocal(props.dataItem[props.field], DATETIME_FORMAT);
  if (!date) {
    return <td className={props.className} />;
  }

  return (
    <td onClick={expandDataItem} className={props.className}>
      {date}
    </td>
  );
};

CellDate.propTypes = {
  dataItem: PropTypes.shape({
    dataItem: PropTypes.array
  }),
  field: PropTypes.string,
  className: PropTypes.string
};

CellDateTime.propTypes = {
  dataItem: PropTypes.shape({
    dataItem: PropTypes.array
  }),
  field: PropTypes.string,
  className: PropTypes.string
};
